import * as actions from './../actions/actionConstants.js';

const initialState = {
  seasonsList: [],
  allSeasonsList: [],
  seasons: {},
  allSeasons: {},
  fetchingSeasonsStatus: ''
};

const seasonsReducer = (state = initialState, action) => {
  // console log('Season Reducer calling action:', action)
  // console.log('Season Reducer Init state:', state);
  switch (action.type) {
    case actions.GET_SEASONS:
      return {
        ...state,
        fetchingSeasonsStatus: 'Loading'
      };
    case actions.GET_ALL_SEASONS:
      return {
        ...state,
        fetchingSeasonsStatus: 'Loading'
      };
    case actions.GET_SEASONS_SUCCESS:
      return {
        ...state,
        seasonsList: [...action.seasonsList],
        seasons: { ...action.seasons },
        fetchingSeasonsStatus: 'Loaded'
      };
    case actions.GET_ALL_SEASONS_SUCCESS:
      return {
        ...state,
        allSeasonsList: [...action.seasonsList],
        allSeasons: { ...action.seasons },
        fetchingSeasonsStatus: 'Loaded'
      };
    case actions.GET_SEASONS_ERROR:
      return {
        ...state,
        fetchingSeasonsStatus: 'Error'
      };
    case actions.GET_SEASONS_BY_ACTIVE:
      return {
        ...state,
        fetchingSeasonsStatus: 'Loading'
      };
    case actions.GET_SEASONS_BY_DISPLAY:
      return {
        ...state,
        fetchingSeasonsStatus: 'Loading'
      };
    case actions.UPDATE_SEASON_MAX_DATE_SUCCESS:
      return {
        ...state,
        seasons: {
          ...state.seasons,
          [action.seasonId]: {
            ...state.seasons[action.seasonId],
            maxScheduleDate: action.maxDate
          }
        }
      };
    case actions.UPDATE_SEASON_ACTIVE_SUCCESS:
    return {
      ...state,
      allSeasons: {
        ...state.allSeasons,
        [action.seasonId]: {
          ...state.allSeasons[action.seasonId],
          active: action.active
        }
      }
    };
    case actions.UPDATE_SEASON_DISPLAY_SUCCESS:
    return {
      ...state,
      allSeasons: {
        ...state.allSeasons,
        [action.seasonId]: {
          ...state.allSeasons[action.seasonId],
          display: action.display
        }
      }
    };   
    case actions.UPDATE_SEASON_ACTIVE_ERROR:
    return {
      ...state,
      seasons: {
        ...state.seasons,
        [action.seasonId]: {
          ...state.seasons[action.seasonId],
          active: action.active
        }
      }
    };  
    case actions.USER_LOGOUT:
      return {
        seasonsList: [],
        seasons: {},
        fetchingSeasonsStatus: ''
      };
    /*case actions.GET_SEASONS_BY_ACTIVE_SUCCESS:
      return {
        ...state,
        seasonsList: [...action.seasonsList],
        seasons: { ...action.seasons },
        fetchingSeasonsStatus: 'Loaded'
      };
    case actions.GET_SEASONS_BY_ACTIVE_ERROR:
      return {
        ...state,
        fetchingSeasonsStatus: 'Error'
      };*/
    default:
      return state;
  }
};

export default seasonsReducer;



// WEBPACK FOOTER //
// ./src/reducers/seasons.js